import React from 'react'
import View from '../../components/my-lessons'
import './my-lessons.styl'

export default function MyLessons() {
    return (<View />)
}
